export const ASSESSMENT_INVITATION_ERROR_CODES = Object.freeze({
	INVALID: 'ASSESSMENT_INVITATION_INVALID',
	EXPIRED: 'ASSESSMENT_INVITATION_EXPIRED',
	RECIPIENT_MISMATCH: 'ASSESSMENT_INVITATION_RECIPIENT_MISMATCH',
	DIFFERENT_ORGANIZATION: 'ASSESSMENT_INVITATION_DIFFERENT_ORGANIZATION'
})

const LANDING_STATE_BY_ERROR_CODE = Object.freeze({
	[ASSESSMENT_INVITATION_ERROR_CODES.INVALID]: 'invalid',
	[ASSESSMENT_INVITATION_ERROR_CODES.EXPIRED]: 'expired',
	[ASSESSMENT_INVITATION_ERROR_CODES.RECIPIENT_MISMATCH]: 'invalid',
	[ASSESSMENT_INVITATION_ERROR_CODES.DIFFERENT_ORGANIZATION]:
		'different-organization'
})

const SHARED_LINK_STATE_BY_ERROR_CODE = Object.freeze({
	[ASSESSMENT_INVITATION_ERROR_CODES.INVALID]: 'invalid',
	[ASSESSMENT_INVITATION_ERROR_CODES.DIFFERENT_ORGANIZATION]:
		'different-organization'
})

export function assessmentInvitationPath(token) {
	return `/assessment-invitation/${token}`
}

export function teamAssessmentPath(jobOfferId) {
	return `/assessment/job-offer/${jobOfferId}?mode=team`
}

export function sharedLinkStateForError(error) {
	const code = error?.response?.data?.code
	const state = SHARED_LINK_STATE_BY_ERROR_CODE[code]

	if (state) {
		return state
	}

	return error?.response?.status === 404 ? 'invalid' : null
}

export function landingStateForError(error) {
	const code = error?.response?.data?.code
	return LANDING_STATE_BY_ERROR_CODE[code] || 'error'
}

export function isTeamAssessmentMode(route) {
	return route?.query?.mode === 'team'
}

export function isTeamAssessmentRoute(route) {
	return (
		isTeamAssessmentMode(route) &&
		/^\/assessment\/job-offer\/[^/]+\/?$/.test(route.path || '')
	)
}

export function assessmentRegistrationRoute(context, assessmentToken) {
	return {
		path: '/auth/register',
		query: {
			type: 'organization_member',
			token: context.organization_invitation_token,
			assessment: assessmentToken,
			email: context.email
		}
	}
}

export function assessmentLoginRoute(assessmentToken) {
	return {
		path: '/auth/login',
		query: {
			redirect: assessmentInvitationPath(assessmentToken)
		}
	}
}
